// Auto-généré - Données depuis la base de données
export const lignesBase = [
  {
    "id": "cmj68ks4g0001v3b1l053szxo",
    "numero": "4201",
    "nom": "LIGNE_4201",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "04:30",
    "heureFin": "00:30",
    "calendrierJson": "{\"lundi\":true,\"mardi\":true,\"mercredi\":true,\"jeudi\":true,\"vendredi\":true,\"samedi\":true,\"dimanche\":true}",
    "demandeChrono": false,
    "contraintes": "[\"Jours ouvrables\"]",
    "createdAt": "2025-12-14T21:27:58.048Z",
    "updatedAt": "2025-12-17T22:18:04.525Z",
    "sens": [
      {
        "id": "cmj9oo0ga000213janvfg64gm",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Aller",
        "direction": "Gare SNCF → Centre Ville",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T07:21:41.194Z",
        "updatedAt": "2025-12-17T07:28:10.973Z",
        "services": []
      },
      {
        "id": "cmj9re8jz001mer5becbvtj71",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Aller (DIMFER)",
        "direction": "Saint-Michel-sur-Orge (Rue Berlioz) → Corbeil-Essonnes (Gare E. Zola)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T08:38:03.983Z",
        "updatedAt": "2025-12-17T08:42:36.101Z",
        "services": []
      },
      {
        "id": "cmj9re8j7001aer5bmsg23ntu",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Aller (SAM)",
        "direction": "Saint-Michel-sur-Orge (Rue Berlioz) → Corbeil-Essonnes (Gare E. Zola)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T08:38:03.955Z",
        "updatedAt": "2025-12-17T08:42:36.087Z",
        "services": []
      },
      {
        "id": "cmj9re8fx0002er5bmobfubum",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Aller (SEMAINE)",
        "direction": "Saint-Michel-sur-Orge (Rue Berlioz) → Corbeil-Essonnes (Gare E. Zola)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T08:38:03.836Z",
        "updatedAt": "2025-12-17T08:42:36.053Z",
        "services": []
      },
      {
        "id": "cmjajckto004y31scu0pzm8o0",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "DIMFER - Aller",
        "direction": "Gare SNCF → Centre Ville",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:35.821Z",
        "updatedAt": "2025-12-17T22:18:04.560Z",
        "services": []
      },
      {
        "id": "cmjajckve005s31sc0uhnzlif",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "DIMFER - Retour",
        "direction": "Centre Ville → Gare SNCF",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:35.883Z",
        "updatedAt": "2025-12-17T22:18:04.564Z",
        "services": []
      },
      {
        "id": "cmj9oo0hp000o13japak77nt4",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Retour",
        "direction": "Centre Ville → Gare SNCF",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T07:21:41.245Z",
        "updatedAt": "2025-12-17T07:28:10.983Z",
        "services": []
      },
      {
        "id": "cmj9re8kd001ser5bkg3kex8c",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Retour (DIMFER)",
        "direction": "Corbeil-Essonnes (Gare E. Zola) → Saint-Michel-sur-Orge (Rue Berlioz)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T08:38:03.998Z",
        "updatedAt": "2025-12-17T08:42:36.107Z",
        "services": []
      },
      {
        "id": "cmj9re8jl001ger5b2epe9zs7",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Retour (SAM)",
        "direction": "Corbeil-Essonnes (Gare E. Zola) → Saint-Michel-sur-Orge (Rue Berlioz)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T08:38:03.970Z",
        "updatedAt": "2025-12-17T08:42:36.094Z",
        "services": []
      },
      {
        "id": "cmj9re8hp000oer5bdppkzsjz",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "Retour (SEMAINE)",
        "direction": "Corbeil-Essonnes (Gare E. Zola) → Saint-Michel-sur-Orge (Rue Berlioz)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T08:38:03.901Z",
        "updatedAt": "2025-12-17T08:42:36.072Z",
        "services": []
      },
      {
        "id": "cmjajckoz002i31sczj88fytu",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "SAMEDI - Aller",
        "direction": "Gare SNCF → Centre Ville",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:35.651Z",
        "updatedAt": "2025-12-17T22:18:04.551Z",
        "services": []
      },
      {
        "id": "cmjajckrc003q31scshrp0hgf",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "SAMEDI - Retour",
        "direction": "Centre Ville → Gare SNCF",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:35.736Z",
        "updatedAt": "2025-12-17T22:18:04.555Z",
        "services": []
      },
      {
        "id": "cmjajckjt000231scp2bg5mm4",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "SEMAINE - Aller",
        "direction": "Gare SNCF → Centre Ville",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:35.465Z",
        "updatedAt": "2025-12-17T22:18:04.530Z",
        "services": []
      },
      {
        "id": "cmjajckmj001a31sc7ai95q09",
        "ligneId": "cmj68ks4g0001v3b1l053szxo",
        "nom": "SEMAINE - Retour",
        "direction": "Centre Ville → Gare SNCF",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:35.564Z",
        "updatedAt": "2025-12-17T22:18:04.543Z",
        "services": []
      }
    ]
  },
  {
    "id": "cmjajclis00i731scaihxc440",
    "numero": "4204",
    "nom": "LIGNE_4204",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "05:20",
    "heureFin": "23:00",
    "calendrierJson": "{\"lundi\":true,\"mardi\":true,\"mercredi\":true,\"jeudi\":true,\"vendredi\":true,\"samedi\":true,\"dimanche\":true}",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T21:40:36.724Z",
    "updatedAt": "2025-12-17T22:18:04.660Z",
    "sens": [
      {
        "id": "cmjajclqp00md31sci17sjptw",
        "ligneId": "cmjajclis00i731scaihxc440",
        "nom": "DIMFER - Aller",
        "direction": "Gare d'Orangis Bois de l'Épine → Les Meillottes (Soisy-sur-Seine)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:37.010Z",
        "updatedAt": "2025-12-17T22:18:04.709Z",
        "services": []
      },
      {
        "id": "cmjajcls700n731sc8p8p0q1m",
        "ligneId": "cmjajclis00i731scaihxc440",
        "nom": "DIMFER - Retour",
        "direction": "Les Meillottes (Soisy-sur-Seine) → Gare d'Orangis Bois de l'Épine",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:37.064Z",
        "updatedAt": "2025-12-17T22:18:04.715Z",
        "services": []
      },
      {
        "id": "cmjajcln300kp31sc60pifll1",
        "ligneId": "cmjajclis00i731scaihxc440",
        "nom": "SAMEDI - Aller",
        "direction": "Gare d'Orangis Bois de l'Épine → Les Meillottes (Soisy-sur-Seine)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:36.880Z",
        "updatedAt": "2025-12-17T22:18:04.691Z",
        "services": []
      },
      {
        "id": "cmjajclov00lj31sc6q5ryvx4",
        "ligneId": "cmjajclis00i731scaihxc440",
        "nom": "SAMEDI - Retour",
        "direction": "Les Meillottes (Soisy-sur-Seine) → Gare d'Orangis Bois de l'Épine",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:36.943Z",
        "updatedAt": "2025-12-17T22:18:04.703Z",
        "services": []
      },
      {
        "id": "cmjajcliv00i931scdtiwvzev",
        "ligneId": "cmjajclis00i731scaihxc440",
        "nom": "SEMAINE - Aller",
        "direction": "Gare d'Orangis Bois de l'Épine → Les Meillottes (Soisy-sur-Seine)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:36.727Z",
        "updatedAt": "2025-12-17T22:18:04.663Z",
        "services": []
      },
      {
        "id": "cmjajclky00jh31scc81sb46p",
        "ligneId": "cmjajclis00i731scaihxc440",
        "nom": "SEMAINE - Retour",
        "direction": "Les Meillottes (Soisy-sur-Seine) → Gare d'Orangis Bois de l'Épine",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:36.803Z",
        "updatedAt": "2025-12-17T22:18:04.679Z",
        "services": []
      }
    ]
  },
  {
    "id": "cmjajckx7006l31scvzat060w",
    "numero": "4202",
    "nom": "LIGNE_4202",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "04:21",
    "heureFin": "00:19",
    "calendrierJson": "\"L; M; M; J; V; S; D\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T21:40:35.948Z",
    "updatedAt": "2025-12-18T21:35:13.249Z",
    "sens": [
      {
        "id": "cmjajcl6q00bj31scvqeebzii",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "DIMFER - Aller",
        "direction": "Évry-Courcouronnes → Ris-Orangis (Aunettes / Val de Ris)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:36.291Z",
        "updatedAt": "2025-12-17T22:18:04.605Z",
        "services": []
      },
      {
        "id": "cmjajcl8b00cd31sc29qm56vx",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "DIMFER - Retour",
        "direction": "Ris-Orangis (Val de Ris) → Évry-Courcouronnes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:36.347Z",
        "updatedAt": "2025-12-17T22:18:04.610Z",
        "services": []
      },
      {
        "id": "cmjajcl22009331scaevp13cf",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "SAMEDI - Aller",
        "direction": "Évry-Courcouronnes → Ris-Orangis (Aunettes / Val de Ris)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:36.122Z",
        "updatedAt": "2025-12-17T22:18:04.593Z",
        "services": []
      },
      {
        "id": "cmjajcl4g00ab31scno6nlhoh",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "SAMEDI - Retour",
        "direction": "Ris-Orangis (Val de Ris) → Évry-Courcouronnes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:36.208Z",
        "updatedAt": "2025-12-17T22:18:04.599Z",
        "services": []
      },
      {
        "id": "cmjajckxb006n31sct2dja5g9",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "SEMAINE - Aller",
        "direction": "Évry-Courcouronnes → Ris-Orangis (Aunettes / Val de Ris)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:35.951Z",
        "updatedAt": "2025-12-17T22:18:04.571Z",
        "services": []
      },
      {
        "id": "cmjajckzm007v31scnj7e0q03",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "SEMAINE - Retour",
        "direction": "Ris-Orangis (Val de Ris) → Évry-Courcouronnes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:36.035Z",
        "updatedAt": "2025-12-17T22:18:04.582Z",
        "services": []
      },
      {
        "id": "cmjakqwwq0002wb7sedtuk2vp",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "Semaine Aller",
        "direction": "RIS-ORANGISGare de Ris-Orangis Val de Ris → EVRY-COURCOURONNESAunettes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.282Z",
        "updatedAt": "2025-12-18T21:35:13.298Z",
        "services": [
          {
            "id": "cmjbyliox00045p7681oslk7m",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "04:48",
            "heureFin": "14:48",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.377Z",
            "updatedAt": "2025-12-18T21:35:13.377Z"
          },
          {
            "id": "cmjbyliqj00065p76fux0v6zx",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "04:48",
            "heureFin": "14:48",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.435Z",
            "updatedAt": "2025-12-18T21:35:13.435Z"
          },
          {
            "id": "cmjbylirj00085p76sqhyqmuo",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "04:48",
            "heureFin": "14:48",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.471Z",
            "updatedAt": "2025-12-18T21:35:13.471Z"
          },
          {
            "id": "cmjbylisk000a5p76wvgmx1es",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "04:48",
            "heureFin": "14:48",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.509Z",
            "updatedAt": "2025-12-18T21:35:13.509Z"
          },
          {
            "id": "cmjbylitl000c5p76dz6rtl6j",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "04:48",
            "heureFin": "14:48",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.545Z",
            "updatedAt": "2025-12-18T21:35:13.545Z"
          },
          {
            "id": "cmjbyliul000e5p760p5h8fl5",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "14:48",
            "heureFin": "00:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.581Z",
            "updatedAt": "2025-12-18T21:35:13.581Z"
          },
          {
            "id": "cmjbylivm000g5p76808g7ayf",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "14:48",
            "heureFin": "00:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.619Z",
            "updatedAt": "2025-12-18T21:35:13.619Z"
          },
          {
            "id": "cmjbyliwn000i5p76jicogxr1",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "14:48",
            "heureFin": "00:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.655Z",
            "updatedAt": "2025-12-18T21:35:13.655Z"
          },
          {
            "id": "cmjbylixk000k5p76rfz0869e",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "14:48",
            "heureFin": "00:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.689Z",
            "updatedAt": "2025-12-18T21:35:13.689Z"
          },
          {
            "id": "cmjbyliyh000m5p76jotot41w",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwwq0002wb7sedtuk2vp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "14:48",
            "heureFin": "00:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.722Z",
            "updatedAt": "2025-12-18T21:35:13.722Z"
          }
        ]
      },
      {
        "id": "cmjakqwxx000owb7sukqa7ikk",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "Semaine Retour",
        "direction": "EVRY-COURCOURONNESAunettes → RIS-ORANGISGare de Ris-Orangis Val de Ris",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.325Z",
        "updatedAt": "2025-12-18T21:35:13.739Z",
        "services": [
          {
            "id": "cmjbylizy000q5p76nog6ep40",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "04:21",
            "heureFin": "14:21",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.775Z",
            "updatedAt": "2025-12-18T21:35:13.775Z"
          },
          {
            "id": "cmjbylj0w000s5p769gxiw3oc",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "04:21",
            "heureFin": "14:21",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.809Z",
            "updatedAt": "2025-12-18T21:35:13.809Z"
          },
          {
            "id": "cmjbylj1w000u5p768eczd2ev",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "04:21",
            "heureFin": "14:21",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.845Z",
            "updatedAt": "2025-12-18T21:35:13.845Z"
          },
          {
            "id": "cmjbylj2x000w5p7619pxkmjx",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "04:21",
            "heureFin": "14:21",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.881Z",
            "updatedAt": "2025-12-18T21:35:13.881Z"
          },
          {
            "id": "cmjbylj3z000y5p76heapjgrp",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "04:21",
            "heureFin": "14:21",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.919Z",
            "updatedAt": "2025-12-18T21:35:13.919Z"
          },
          {
            "id": "cmjbylj4z00105p76lw2z2pmn",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "14:21",
            "heureFin": "00:18",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.955Z",
            "updatedAt": "2025-12-18T21:35:13.955Z"
          },
          {
            "id": "cmjbylj6100125p76bxc4gebn",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "14:21",
            "heureFin": "00:18",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:13.993Z",
            "updatedAt": "2025-12-18T21:35:13.993Z"
          },
          {
            "id": "cmjbylj7000145p76dfydj21q",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "14:21",
            "heureFin": "00:18",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.029Z",
            "updatedAt": "2025-12-18T21:35:14.029Z"
          },
          {
            "id": "cmjbylj8100165p76dsuk4szu",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "14:21",
            "heureFin": "00:18",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.065Z",
            "updatedAt": "2025-12-18T21:35:14.065Z"
          },
          {
            "id": "cmjbylj9300185p76rw4ivqzk",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwxx000owb7sukqa7ikk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "14:21",
            "heureFin": "00:18",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.103Z",
            "updatedAt": "2025-12-18T21:35:14.103Z"
          }
        ]
      },
      {
        "id": "cmjakqwyu001awb7s5vo0tlnw",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "Samedi Aller",
        "direction": "RIS-ORANGISGare de Ris-Orangis Val de Ris → EVRY-COURCOURONNESAunettes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.359Z",
        "updatedAt": "2025-12-18T21:35:14.123Z",
        "services": [
          {
            "id": "cmjbyljan001c5p765znincas",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwyu001awb7s5vo0tlnw",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "05:09",
            "heureFin": "15:09",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.159Z",
            "updatedAt": "2025-12-18T21:35:14.159Z"
          },
          {
            "id": "cmjbyljbn001e5p76nfqqix3q",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwyu001awb7s5vo0tlnw",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "15:09",
            "heureFin": "23:54",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.195Z",
            "updatedAt": "2025-12-18T21:35:14.195Z"
          }
        ]
      },
      {
        "id": "cmjakqwz5001gwb7siw35bd1h",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "Samedi Retour",
        "direction": "EVRY-COURCOURONNESAunettes → RIS-ORANGISGare de Ris-Orangis Val de Ris",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.369Z",
        "updatedAt": "2025-12-18T21:35:14.213Z",
        "services": [
          {
            "id": "cmjbyljd7001i5p760rsfdaly",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwz5001gwb7siw35bd1h",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "05:17",
            "heureFin": "15:17",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.252Z",
            "updatedAt": "2025-12-18T21:35:14.252Z"
          },
          {
            "id": "cmjbylje6001k5p761ga9xpeu",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwz5001gwb7siw35bd1h",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "15:17",
            "heureFin": "00:03",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.287Z",
            "updatedAt": "2025-12-18T21:35:14.287Z"
          }
        ]
      },
      {
        "id": "cmjakqwze001mwb7saf966dbn",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "Dimanche & fériés Aller",
        "direction": "RIS-ORANGISGare de Ris-Orangis Val de Ris → EVRY-COURCOURONNESAunettes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.378Z",
        "updatedAt": "2025-12-18T21:35:14.303Z",
        "services": [
          {
            "id": "cmjbyljfn001o5p76raabpugw",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwze001mwb7saf966dbn",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:32",
            "heureFin": "15:32",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.339Z",
            "updatedAt": "2025-12-18T21:35:14.339Z"
          },
          {
            "id": "cmjbyljgn001q5p76c90y4k7o",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwze001mwb7saf966dbn",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:32",
            "heureFin": "00:11",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.375Z",
            "updatedAt": "2025-12-18T21:35:14.375Z"
          }
        ]
      },
      {
        "id": "cmjakqwzo001swb7shant3cmq",
        "ligneId": "cmjajckx7006l31scvzat060w",
        "nom": "Dimanche & fériés Retour",
        "direction": "EVRY-COURCOURONNESAunettes → RIS-ORANGISGare de Ris-Orangis Val de Ris",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.388Z",
        "updatedAt": "2025-12-18T21:35:14.393Z",
        "services": [
          {
            "id": "cmjbylji7001u5p76ebd99k97",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwzo001swb7shant3cmq",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:21",
            "heureFin": "15:21",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.431Z",
            "updatedAt": "2025-12-18T21:35:14.431Z"
          },
          {
            "id": "cmjbyljj6001w5p76hvytml9h",
            "ligneId": "cmjajckx7006l31scvzat060w",
            "sensId": "cmjakqwzo001swb7shant3cmq",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:21",
            "heureFin": "23:43",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.467Z",
            "updatedAt": "2025-12-18T21:35:14.467Z"
          }
        ]
      }
    ]
  },
  {
    "id": "cmjajcla500d631scfz9zkcei",
    "numero": "4203",
    "nom": "LIGNE_4203",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "04:57",
    "heureFin": "00:53",
    "calendrierJson": "\"L; M; M; J; V; S; D\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T21:40:36.414Z",
    "updatedAt": "2025-12-18T21:35:14.484Z",
    "sens": [
      {
        "id": "cmjajclfz00gk31scgcy58ubj",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "DIMFER - Aller",
        "direction": "Corbeil-Essonnes → (terminus selon fiche)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:36.623Z",
        "updatedAt": "2025-12-17T22:18:04.646Z",
        "services": []
      },
      {
        "id": "cmjajclhd00he31sc8yvqmsnh",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "DIMFER - Retour",
        "direction": "(terminus) → Corbeil-Essonnes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:36.673Z",
        "updatedAt": "2025-12-17T22:18:04.653Z",
        "services": []
      },
      {
        "id": "cmjajcld400ew31scnyb8a41b",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "SAMEDI - Aller",
        "direction": "Corbeil-Essonnes → (terminus selon fiche)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:36.520Z",
        "updatedAt": "2025-12-17T22:18:04.636Z",
        "services": []
      },
      {
        "id": "cmjajcleh00fq31sccjk2sfpx",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "SAMEDI - Retour",
        "direction": "(terminus) → Corbeil-Essonnes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:36.569Z",
        "updatedAt": "2025-12-17T22:18:04.641Z",
        "services": []
      },
      {
        "id": "cmjajcla800d831scf3itie9l",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "SEMAINE - Aller",
        "direction": "Corbeil-Essonnes → (terminus selon fiche)",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:36.417Z",
        "updatedAt": "2025-12-17T22:18:04.617Z",
        "services": []
      },
      {
        "id": "cmjajclbo00e231sced805gkw",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "SEMAINE - Retour",
        "direction": "(terminus) → Corbeil-Essonnes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:36.468Z",
        "updatedAt": "2025-12-17T22:18:04.626Z",
        "services": []
      },
      {
        "id": "cmjakqx03001zwb7s83ueyyhg",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "Semaine Aller",
        "direction": "LE-COUDRAY-MONTCEAUXTerminal David Douillet → CORBEIL-ESSONNESSnecma / Safran",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.403Z",
        "updatedAt": "2025-12-18T21:35:14.501Z",
        "services": [
          {
            "id": "cmjbyljl300215p76xv1e7anm",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "04:57",
            "heureFin": "14:57",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.535Z",
            "updatedAt": "2025-12-18T21:35:14.535Z"
          },
          {
            "id": "cmjbyljm200235p76t8o8dzah",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "04:57",
            "heureFin": "14:57",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.571Z",
            "updatedAt": "2025-12-18T21:35:14.571Z"
          },
          {
            "id": "cmjbyljn700255p76mgm1ll8t",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "04:57",
            "heureFin": "14:57",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.611Z",
            "updatedAt": "2025-12-18T21:35:14.611Z"
          },
          {
            "id": "cmjbyljo700275p769ldhrbv1",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "04:57",
            "heureFin": "14:57",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.647Z",
            "updatedAt": "2025-12-18T21:35:14.647Z"
          },
          {
            "id": "cmjbyljp700295p76fribklec",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "04:57",
            "heureFin": "14:57",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.683Z",
            "updatedAt": "2025-12-18T21:35:14.683Z"
          },
          {
            "id": "cmjbyljq7002b5p76g0bfu7hn",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "14:57",
            "heureFin": "00:42",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.719Z",
            "updatedAt": "2025-12-18T21:35:14.719Z"
          },
          {
            "id": "cmjbyljr7002d5p7637dhhzqg",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "14:57",
            "heureFin": "00:42",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.755Z",
            "updatedAt": "2025-12-18T21:35:14.755Z"
          },
          {
            "id": "cmjbyljs7002f5p76m1bx9xqh",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "14:57",
            "heureFin": "00:42",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.791Z",
            "updatedAt": "2025-12-18T21:35:14.791Z"
          },
          {
            "id": "cmjbyljt7002h5p76ohtz6zwx",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "14:57",
            "heureFin": "00:42",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.828Z",
            "updatedAt": "2025-12-18T21:35:14.828Z"
          },
          {
            "id": "cmjbylju9002j5p76haba27cp",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx03001zwb7s83ueyyhg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "14:57",
            "heureFin": "00:42",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.865Z",
            "updatedAt": "2025-12-18T21:35:14.865Z"
          }
        ]
      },
      {
        "id": "cmjakqx16002lwb7s1mm0wobi",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "Semaine Retour",
        "direction": "CORBEIL-ESSONNESSnecma / Safran → LE-COUDRAY-MONTCEAUXTerminal David Douillet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.443Z",
        "updatedAt": "2025-12-18T21:35:14.884Z",
        "services": [
          {
            "id": "cmjbyljvq002n5p76w5wstqbc",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "05:19",
            "heureFin": "15:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.919Z",
            "updatedAt": "2025-12-18T21:35:14.919Z"
          },
          {
            "id": "cmjbyljwn002p5p76kx9cxa3d",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "05:19",
            "heureFin": "15:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.951Z",
            "updatedAt": "2025-12-18T21:35:14.951Z"
          },
          {
            "id": "cmjbyljxn002r5p7622kkxz5x",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "05:19",
            "heureFin": "15:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:14.987Z",
            "updatedAt": "2025-12-18T21:35:14.987Z"
          },
          {
            "id": "cmjbyljym002t5p7665e9bloz",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "05:19",
            "heureFin": "15:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.023Z",
            "updatedAt": "2025-12-18T21:35:15.023Z"
          },
          {
            "id": "cmjbyljzn002v5p76aad2yl7p",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "05:19",
            "heureFin": "15:19",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.059Z",
            "updatedAt": "2025-12-18T21:35:15.059Z"
          },
          {
            "id": "cmjbylk0n002x5p76ky2hmg2g",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "15:19",
            "heureFin": "00:53",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.095Z",
            "updatedAt": "2025-12-18T21:35:15.095Z"
          },
          {
            "id": "cmjbylk1l002z5p76kzrbes9o",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "15:19",
            "heureFin": "00:53",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.129Z",
            "updatedAt": "2025-12-18T21:35:15.129Z"
          },
          {
            "id": "cmjbylk2l00315p76ls7cck7s",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "15:19",
            "heureFin": "00:53",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.165Z",
            "updatedAt": "2025-12-18T21:35:15.165Z"
          },
          {
            "id": "cmjbylk3l00335p76ck8dnexb",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "15:19",
            "heureFin": "00:53",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.201Z",
            "updatedAt": "2025-12-18T21:35:15.201Z"
          },
          {
            "id": "cmjbylk4l00355p76k27oirzs",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx16002lwb7s1mm0wobi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "15:19",
            "heureFin": "00:53",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.237Z",
            "updatedAt": "2025-12-18T21:35:15.237Z"
          }
        ]
      },
      {
        "id": "cmjakqx2c0037wb7s47mud3n6",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "Samedi Aller",
        "direction": "LE-COUDRAY-MONTCEAUXTerminal David Douillet → CORBEIL-ESSONNESSnecma / Safran",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.484Z",
        "updatedAt": "2025-12-18T21:35:15.255Z",
        "services": [
          {
            "id": "cmjbylk6200395p76iiawu688",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx2c0037wb7s47mud3n6",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.291Z",
            "updatedAt": "2025-12-18T21:35:15.291Z"
          },
          {
            "id": "cmjbylk71003b5p764kihu32v",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx2c0037wb7s47mud3n6",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:09",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.325Z",
            "updatedAt": "2025-12-18T21:35:15.325Z"
          }
        ]
      },
      {
        "id": "cmjakqx2l003dwb7s0zfldy7v",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "Samedi Retour",
        "direction": "CORBEIL-ESSONNESSnecma / Safran → LE-COUDRAY-MONTCEAUXTerminal David Douillet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.494Z",
        "updatedAt": "2025-12-18T21:35:15.343Z",
        "services": [
          {
            "id": "cmjbylk8i003f5p765tvhg3ve",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx2l003dwb7s0zfldy7v",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "05:17",
            "heureFin": "15:17",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.379Z",
            "updatedAt": "2025-12-18T21:35:15.379Z"
          },
          {
            "id": "cmjbylk9j003h5p762o2cdv79",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx2l003dwb7s0zfldy7v",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "15:17",
            "heureFin": "00:24",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.415Z",
            "updatedAt": "2025-12-18T21:35:15.415Z"
          }
        ]
      },
      {
        "id": "cmjakqx2u003jwb7sc0qr3pcl",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "Dimanche & fériés Aller",
        "direction": "LE-COUDRAY-MONTCEAUXTerminal David Douillet → CORBEIL-ESSONNESSnecma / Safran",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.503Z",
        "updatedAt": "2025-12-18T21:35:15.435Z",
        "services": [
          {
            "id": "cmjbylkb3003l5p76q5lagjwy",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx2u003jwb7sc0qr3pcl",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.471Z",
            "updatedAt": "2025-12-18T21:35:15.471Z"
          },
          {
            "id": "cmjbylkc3003n5p76jc6l6xkc",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx2u003jwb7sc0qr3pcl",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:41",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.507Z",
            "updatedAt": "2025-12-18T21:35:15.507Z"
          }
        ]
      },
      {
        "id": "cmjakqx35003pwb7supe6mtaf",
        "ligneId": "cmjajcla500d631scfz9zkcei",
        "nom": "Dimanche & fériés Retour",
        "direction": "CORBEIL-ESSONNESSnecma / Safran → LE-COUDRAY-MONTCEAUXTerminal David Douillet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.514Z",
        "updatedAt": "2025-12-18T21:35:15.525Z",
        "services": [
          {
            "id": "cmjbylkdl003r5p7672k5o9ug",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx35003pwb7supe6mtaf",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:20",
            "heureFin": "15:20",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.562Z",
            "updatedAt": "2025-12-18T21:35:15.562Z"
          },
          {
            "id": "cmjbylkel003t5p76t6nnajt3",
            "ligneId": "cmjajcla500d631scfz9zkcei",
            "sensId": "cmjakqx35003pwb7supe6mtaf",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:20",
            "heureFin": "00:31",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.597Z",
            "updatedAt": "2025-12-18T21:35:15.597Z"
          }
        ]
      }
    ]
  },
  {
    "id": "cmjajcltr00o031scj0vsg01j",
    "numero": "4205",
    "nom": "LIGNE_4205",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "05:00",
    "heureFin": "00:48",
    "calendrierJson": "\"L; M; M; J; V; S; D\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T21:40:37.119Z",
    "updatedAt": "2025-12-18T21:35:15.615Z",
    "sens": [
      {
        "id": "cmjajclzt00re31scg7hanyr2",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "DIMFER - Aller",
        "direction": "Gare de Juvisy - Condorcet → Viry/Grigny",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:37.338Z",
        "updatedAt": "2025-12-17T22:18:04.753Z",
        "services": []
      },
      {
        "id": "cmjajcm1i00s831scn5mvrrh6",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "DIMFER - Retour",
        "direction": "Viry/Grigny → Gare de Juvisy - Condorcet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T21:40:37.398Z",
        "updatedAt": "2025-12-17T22:18:04.758Z",
        "services": []
      },
      {
        "id": "cmjajclwv00pq31scqb1zoys3",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "SAMEDI - Aller",
        "direction": "Gare de Juvisy - Condorcet → Viry/Grigny",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:37.232Z",
        "updatedAt": "2025-12-17T22:18:04.744Z",
        "services": []
      },
      {
        "id": "cmjajclyd00qk31scxo7ejdjn",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "SAMEDI - Retour",
        "direction": "Viry/Grigny → Gare de Juvisy - Condorcet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T21:40:37.286Z",
        "updatedAt": "2025-12-17T22:18:04.749Z",
        "services": []
      },
      {
        "id": "cmjajcltt00o231scqkksoett",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "SEMAINE - Aller",
        "direction": "Gare de Juvisy - Condorcet → Viry/Grigny",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:37.122Z",
        "updatedAt": "2025-12-17T22:18:04.724Z",
        "services": []
      },
      {
        "id": "cmjajclvc00ow31scnwbrrl5r",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "SEMAINE - Retour",
        "direction": "Viry/Grigny → Gare de Juvisy - Condorcet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T21:40:37.176Z",
        "updatedAt": "2025-12-17T22:18:04.735Z",
        "services": []
      },
      {
        "id": "cmjakqx4l004iwb7s8u9a8pkb",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "Semaine Retour",
        "direction": "JUVISY-SUR-ORGEGare de Juvisy - Condorcet → VIRY-CHÂTILLONLa Treille",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.565Z",
        "updatedAt": "2025-12-18T21:35:16.010Z",
        "services": [
          {
            "id": "cmjbylkr1004k5p76kxvuwve7",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.045Z",
            "updatedAt": "2025-12-18T21:35:16.045Z"
          },
          {
            "id": "cmjbylkry004m5p76ic68qyd1",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.079Z",
            "updatedAt": "2025-12-18T21:35:16.079Z"
          },
          {
            "id": "cmjbylksz004o5p76p66xkhis",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.116Z",
            "updatedAt": "2025-12-18T21:35:16.116Z"
          },
          {
            "id": "cmjbylktz004q5p76p6kk56cu",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.151Z",
            "updatedAt": "2025-12-18T21:35:16.151Z"
          },
          {
            "id": "cmjbylkuy004s5p763aec5sf8",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.187Z",
            "updatedAt": "2025-12-18T21:35:16.187Z"
          },
          {
            "id": "cmjbylkvx004u5p764i4410ve",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:28",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.221Z",
            "updatedAt": "2025-12-18T21:35:16.221Z"
          },
          {
            "id": "cmjbylkww004w5p76pyydqlpc",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:28",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.257Z",
            "updatedAt": "2025-12-18T21:35:16.257Z"
          },
          {
            "id": "cmjbylkxy004y5p76nige6hm6",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:28",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.294Z",
            "updatedAt": "2025-12-18T21:35:16.294Z"
          },
          {
            "id": "cmjbylkz100505p76w51aplba",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:28",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.333Z",
            "updatedAt": "2025-12-18T21:35:16.333Z"
          },
          {
            "id": "cmjbyll0000525p76jy0zs24q",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx4l004iwb7s8u9a8pkb",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:28",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.369Z",
            "updatedAt": "2025-12-18T21:35:16.369Z"
          }
        ]
      },
      {
        "id": "cmjakqx5h0054wb7scc5sx9vk",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "Samedi Aller",
        "direction": "VIRY-CHÂTILLONLa Treille → JUVISY-SUR-ORGEGare de Juvisy - Condorcet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.597Z",
        "updatedAt": "2025-12-18T21:35:16.387Z",
        "services": [
          {
            "id": "cmjbyll1j00565p76ghnwj1s9",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx5h0054wb7scc5sx9vk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "05:02",
            "heureFin": "15:02",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.423Z",
            "updatedAt": "2025-12-18T21:35:16.423Z"
          },
          {
            "id": "cmjbyll2j00585p76pvc3rifl",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx5h0054wb7scc5sx9vk",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "15:02",
            "heureFin": "23:50",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.459Z",
            "updatedAt": "2025-12-18T21:35:16.459Z"
          }
        ]
      },
      {
        "id": "cmjakqx5x005gwb7shsb658wd",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "Dimanche & fériés Aller",
        "direction": "VIRY-CHÂTILLONLa Treille → JUVISY-SUR-ORGEGare de Juvisy - Condorcet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.614Z",
        "updatedAt": "2025-12-18T21:35:16.571Z",
        "services": [
          {
            "id": "cmjbyll6n005i5p76s7upnp4a",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx5x005gwb7shsb658wd",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:30",
            "heureFin": "15:30",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.607Z",
            "updatedAt": "2025-12-18T21:35:16.607Z"
          },
          {
            "id": "cmjbyll7n005k5p768kxoi9pd",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx5x005gwb7shsb658wd",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:30",
            "heureFin": "22:50",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.643Z",
            "updatedAt": "2025-12-18T21:35:16.643Z"
          }
        ]
      },
      {
        "id": "cmjakqx6d005mwb7s45aushae",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "Dimanche & fériés Retour",
        "direction": "JUVISY-SUR-ORGEGare de Juvisy - Condorcet → VIRY-CHÂTILLONLa Treille",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.630Z",
        "updatedAt": "2025-12-18T21:35:16.663Z",
        "services": [
          {
            "id": "cmjbyll97005o5p76te9v3jro",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx6d005mwb7s45aushae",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:39",
            "heureFin": "15:39",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.699Z",
            "updatedAt": "2025-12-18T21:35:16.699Z"
          },
          {
            "id": "cmjbylla5005q5p76qu3zcz8y",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx6d005mwb7s45aushae",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:39",
            "heureFin": "23:01",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.733Z",
            "updatedAt": "2025-12-18T21:35:16.733Z"
          }
        ]
      },
      {
        "id": "cmjakqx3j003wwb7scgdmjhp9",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "Semaine Aller",
        "direction": "VIRY-CHÂTILLONLa Treille → JUVISY-SUR-ORGEGare de Juvisy - Condorcet",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.528Z",
        "updatedAt": "2025-12-18T21:35:15.634Z",
        "services": [
          {
            "id": "cmjbylkgl003y5p766gw0m2i3",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.669Z",
            "updatedAt": "2025-12-18T21:35:15.669Z"
          },
          {
            "id": "cmjbylkhl00405p76sxf40x4a",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.705Z",
            "updatedAt": "2025-12-18T21:35:15.705Z"
          },
          {
            "id": "cmjbylkil00425p76p6qbdfot",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.741Z",
            "updatedAt": "2025-12-18T21:35:15.741Z"
          },
          {
            "id": "cmjbylkjk00445p76bi9xoqi6",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.777Z",
            "updatedAt": "2025-12-18T21:35:15.777Z"
          },
          {
            "id": "cmjbylkkk00465p76kvf36go1",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.813Z",
            "updatedAt": "2025-12-18T21:35:15.813Z"
          },
          {
            "id": "cmjbylkll00485p76r5l0xfna",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:23",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.849Z",
            "updatedAt": "2025-12-18T21:35:15.849Z"
          },
          {
            "id": "cmjbylkml004a5p76dekjuz03",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:23",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.885Z",
            "updatedAt": "2025-12-18T21:35:15.885Z"
          },
          {
            "id": "cmjbylknl004c5p763sjkn46y",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:23",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.921Z",
            "updatedAt": "2025-12-18T21:35:15.921Z"
          },
          {
            "id": "cmjbylkol004e5p76rq35whma",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:23",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.957Z",
            "updatedAt": "2025-12-18T21:35:15.957Z"
          },
          {
            "id": "cmjbylkpk004g5p76d0ptnnwo",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx3j003wwb7scgdmjhp9",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "00:23",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:15.993Z",
            "updatedAt": "2025-12-18T21:35:15.993Z"
          }
        ]
      },
      {
        "id": "cmjakqx5p005awb7se36ylezg",
        "ligneId": "cmjajcltr00o031scj0vsg01j",
        "nom": "Samedi Retour",
        "direction": "JUVISY-SUR-ORGEGare de Juvisy - Condorcet → VIRY-CHÂTILLONLa Treille",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.606Z",
        "updatedAt": "2025-12-18T21:35:16.478Z",
        "services": [
          {
            "id": "cmjbyll41005c5p76fz30jt7j",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx5p005awb7se36ylezg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "05:54",
            "heureFin": "15:54",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.513Z",
            "updatedAt": "2025-12-18T21:35:16.513Z"
          },
          {
            "id": "cmjbyll51005e5p765kia3raw",
            "ligneId": "cmjajcltr00o031scj0vsg01j",
            "sensId": "cmjakqx5p005awb7se36ylezg",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "15:54",
            "heureFin": "00:48",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.550Z",
            "updatedAt": "2025-12-18T21:35:16.550Z"
          }
        ]
      }
    ]
  },
  {
    "id": "cmjakqx6p005rwb7se44x6z5w",
    "numero": "4206",
    "nom": "LIGNE_4206",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "04:33",
    "heureFin": "00:36",
    "calendrierJson": "\"L; M; M; J; V; S; D\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T22:19:44.641Z",
    "updatedAt": "2025-12-18T21:35:16.773Z",
    "sens": [
      {
        "id": "cmjakqx6t005twb7sxinsqarp",
        "ligneId": "cmjakqx6p005rwb7se44x6z5w",
        "nom": "Semaine Aller",
        "direction": "VIRY-CHÂTILLONLa Treille → CORBEIL-ESSONNESGare de Corbeil-Essonnes - E. Zola",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.645Z",
        "updatedAt": "2025-12-18T21:35:16.794Z",
        "services": [
          {
            "id": "cmjbyllcv005v5p76vs3puu2c",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "04:38",
            "heureFin": "14:38",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.831Z",
            "updatedAt": "2025-12-18T21:35:16.831Z"
          },
          {
            "id": "cmjbylldv005x5p76f5j8e8u7",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "04:38",
            "heureFin": "14:38",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.868Z",
            "updatedAt": "2025-12-18T21:35:16.868Z"
          },
          {
            "id": "cmjbyllev005z5p76q9be3uci",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "04:38",
            "heureFin": "14:38",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.903Z",
            "updatedAt": "2025-12-18T21:35:16.903Z"
          },
          {
            "id": "cmjbyllfv00615p76zmjl1432",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "04:38",
            "heureFin": "14:38",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.939Z",
            "updatedAt": "2025-12-18T21:35:16.939Z"
          },
          {
            "id": "cmjbyllgv00635p76vk78fyvi",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "04:38",
            "heureFin": "14:38",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:16.976Z",
            "updatedAt": "2025-12-18T21:35:16.976Z"
          },
          {
            "id": "cmjbyllhx00655p76rrodn7yh",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "14:38",
            "heureFin": "00:32",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.013Z",
            "updatedAt": "2025-12-18T21:35:17.013Z"
          },
          {
            "id": "cmjbyllix00675p76vrleoh6u",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "14:38",
            "heureFin": "00:32",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.049Z",
            "updatedAt": "2025-12-18T21:35:17.049Z"
          },
          {
            "id": "cmjbyllk100695p767f7kyqj4",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "14:38",
            "heureFin": "00:32",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.089Z",
            "updatedAt": "2025-12-18T21:35:17.089Z"
          },
          {
            "id": "cmjbylllo006b5p76bn0kkc6e",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "14:38",
            "heureFin": "00:32",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.148Z",
            "updatedAt": "2025-12-18T21:35:17.148Z"
          },
          {
            "id": "cmjbyllmp006d5p76btd7exsg",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx6t005twb7sxinsqarp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "14:38",
            "heureFin": "00:32",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.186Z",
            "updatedAt": "2025-12-18T21:35:17.186Z"
          }
        ]
      },
      {
        "id": "cmjakqx82006fwb7s0kvkjd89",
        "ligneId": "cmjakqx6p005rwb7se44x6z5w",
        "nom": "Semaine Retour",
        "direction": "CORBEIL-ESSONNESGare de Corbeil-Essonnes - E. Zola → VIRY-CHÂTILLONLa Treille",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.690Z",
        "updatedAt": "2025-12-18T21:35:17.203Z",
        "services": [
          {
            "id": "cmjbyllo7006h5p76z12atmis",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.239Z",
            "updatedAt": "2025-12-18T21:35:17.239Z"
          },
          {
            "id": "cmjbyllp7006j5p76ukrgmmrd",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.275Z",
            "updatedAt": "2025-12-18T21:35:17.275Z"
          },
          {
            "id": "cmjbyllq7006l5p768rkjtmdw",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.311Z",
            "updatedAt": "2025-12-18T21:35:17.311Z"
          },
          {
            "id": "cmjbyllr7006n5p76hersgkfb",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.347Z",
            "updatedAt": "2025-12-18T21:35:17.347Z"
          },
          {
            "id": "cmjbylls7006p5p760g6cpj99",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.383Z",
            "updatedAt": "2025-12-18T21:35:17.383Z"
          },
          {
            "id": "cmjbyllt9006r5p76gd4vs73u",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:36",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.422Z",
            "updatedAt": "2025-12-18T21:35:17.422Z"
          },
          {
            "id": "cmjbyllu9006t5p76dflbddaj",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:36",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.457Z",
            "updatedAt": "2025-12-18T21:35:17.457Z"
          },
          {
            "id": "cmjbyllv9006v5p76366xecqs",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:36",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.493Z",
            "updatedAt": "2025-12-18T21:35:17.493Z"
          },
          {
            "id": "cmjbyllwb006x5p766l0nhp9s",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:36",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.531Z",
            "updatedAt": "2025-12-18T21:35:17.531Z"
          },
          {
            "id": "cmjbyllxf006z5p76cz726wyo",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx82006fwb7s0kvkjd89",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:36",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.571Z",
            "updatedAt": "2025-12-18T21:35:17.571Z"
          }
        ]
      },
      {
        "id": "cmjakqx960071wb7s7mfdtaml",
        "ligneId": "cmjakqx6p005rwb7se44x6z5w",
        "nom": "Samedi Aller",
        "direction": "VIRY-CHÂTILLONLa Treille → CORBEIL-ESSONNESGare de Corbeil-Essonnes - E. Zola",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.730Z",
        "updatedAt": "2025-12-18T21:35:17.589Z",
        "services": [
          {
            "id": "cmjbyllyz00735p76oq84u1s0",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx960071wb7s7mfdtaml",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "04:38",
            "heureFin": "14:38",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.628Z",
            "updatedAt": "2025-12-18T21:35:17.628Z"
          },
          {
            "id": "cmjbyllzz00755p76ugkybwxa",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx960071wb7s7mfdtaml",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "14:38",
            "heureFin": "00:34",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.663Z",
            "updatedAt": "2025-12-18T21:35:17.663Z"
          }
        ]
      },
      {
        "id": "cmjakqx9f0077wb7s8ntq5f6g",
        "ligneId": "cmjakqx6p005rwb7se44x6z5w",
        "nom": "Samedi Retour",
        "direction": "CORBEIL-ESSONNESGare de Corbeil-Essonnes - E. Zola → VIRY-CHÂTILLONLa Treille",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.739Z",
        "updatedAt": "2025-12-18T21:35:17.682Z",
        "services": [
          {
            "id": "cmjbylm1h00795p7628olobxo",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx9f0077wb7s8ntq5f6g",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.717Z",
            "updatedAt": "2025-12-18T21:35:17.717Z"
          },
          {
            "id": "cmjbylm2h007b5p766qedg4bc",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx9f0077wb7s8ntq5f6g",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:30",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.753Z",
            "updatedAt": "2025-12-18T21:35:17.753Z"
          }
        ]
      },
      {
        "id": "cmjakqx9o007dwb7s9ieqvh5q",
        "ligneId": "cmjakqx6p005rwb7se44x6z5w",
        "nom": "Dimanche & fériés Aller",
        "direction": "VIRY-CHÂTILLONLa Treille → CORBEIL-ESSONNESGare de Corbeil-Essonnes - E. Zola",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.748Z",
        "updatedAt": "2025-12-18T21:35:17.771Z",
        "services": [
          {
            "id": "cmjbylm3z007f5p76kqv8p9mz",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx9o007dwb7s9ieqvh5q",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.807Z",
            "updatedAt": "2025-12-18T21:35:17.807Z"
          },
          {
            "id": "cmjbylm4z007h5p76i43p9u01",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx9o007dwb7s9ieqvh5q",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.843Z",
            "updatedAt": "2025-12-18T21:35:17.843Z"
          }
        ]
      },
      {
        "id": "cmjakqx9x007jwb7s25zu3ttq",
        "ligneId": "cmjakqx6p005rwb7se44x6z5w",
        "nom": "Dimanche & fériés Retour",
        "direction": "CORBEIL-ESSONNESGare de Corbeil-Essonnes - E. Zola → VIRY-CHÂTILLONLa Treille",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.757Z",
        "updatedAt": "2025-12-18T21:35:17.861Z",
        "services": [
          {
            "id": "cmjbylm6h007l5p76c0ub91to",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx9x007jwb7s25zu3ttq",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "04:33",
            "heureFin": "14:33",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.897Z",
            "updatedAt": "2025-12-18T21:35:17.897Z"
          },
          {
            "id": "cmjbylm7i007n5p76nyn6z8yu",
            "ligneId": "cmjakqx6p005rwb7se44x6z5w",
            "sensId": "cmjakqx9x007jwb7s25zu3ttq",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "14:33",
            "heureFin": "00:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:17.934Z",
            "updatedAt": "2025-12-18T21:35:17.934Z"
          }
        ]
      }
    ]
  },
  {
    "id": "cmjakqxa8007owb7skzxm7jmn",
    "numero": "4212",
    "nom": "LIGNE_4212",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "05:00",
    "heureFin": "23:41",
    "calendrierJson": "\"L; M; M; J; V; S; D\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T22:19:44.768Z",
    "updatedAt": "2025-12-18T21:35:17.952Z",
    "sens": [
      {
        "id": "cmjakqxaa007qwb7s4lqwvn9i",
        "ligneId": "cmjakqxa8007owb7skzxm7jmn",
        "nom": "Semaine Aller",
        "direction": "EVRY-COURCOURONNESGare du Bras de Fer-Évry Génopôle → BRETIGNY-SUR-ORGEGare de Brétigny",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.771Z",
        "updatedAt": "2025-12-18T21:35:17.969Z",
        "services": [
          {
            "id": "cmjbylm9h007s5p76wqnys056",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.005Z",
            "updatedAt": "2025-12-18T21:35:18.005Z"
          },
          {
            "id": "cmjbylmah007u5p768b8mc91n",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.041Z",
            "updatedAt": "2025-12-18T21:35:18.041Z"
          },
          {
            "id": "cmjbylmbh007w5p76e5qbcd3k",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.077Z",
            "updatedAt": "2025-12-18T21:35:18.077Z"
          },
          {
            "id": "cmjbylmch007y5p76npt046oq",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.113Z",
            "updatedAt": "2025-12-18T21:35:18.113Z"
          },
          {
            "id": "cmjbylmdh00805p76ta20md71",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.149Z",
            "updatedAt": "2025-12-18T21:35:18.149Z"
          },
          {
            "id": "cmjbylmef00825p76opdubf2q",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.184Z",
            "updatedAt": "2025-12-18T21:35:18.184Z"
          },
          {
            "id": "cmjbylmfd00845p76yy1kqrwn",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.217Z",
            "updatedAt": "2025-12-18T21:35:18.217Z"
          },
          {
            "id": "cmjbylmgd00865p76yq3s8m7q",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.253Z",
            "updatedAt": "2025-12-18T21:35:18.253Z"
          },
          {
            "id": "cmjbylmhd00885p767eup7t2a",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.289Z",
            "updatedAt": "2025-12-18T21:35:18.289Z"
          },
          {
            "id": "cmjbylmid008a5p763rvj42cz",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxaa007qwb7s4lqwvn9i",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:25",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.325Z",
            "updatedAt": "2025-12-18T21:35:18.325Z"
          }
        ]
      },
      {
        "id": "cmjakqxb9008cwb7s7cf7nqzp",
        "ligneId": "cmjakqxa8007owb7skzxm7jmn",
        "nom": "Semaine Retour",
        "direction": "BRETIGNY-SUR-ORGEGare de Brétigny → EVRY-COURCOURONNESGare du Bras de Fer-Évry Génopôle",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.806Z",
        "updatedAt": "2025-12-18T21:35:18.343Z",
        "services": [
          {
            "id": "cmjbylmjv008e5p76y61kv64h",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.379Z",
            "updatedAt": "2025-12-18T21:35:18.379Z"
          },
          {
            "id": "cmjbylmkv008g5p760xaiifv7",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.415Z",
            "updatedAt": "2025-12-18T21:35:18.415Z"
          },
          {
            "id": "cmjbylmlv008i5p76fsi16zn0",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.451Z",
            "updatedAt": "2025-12-18T21:35:18.451Z"
          },
          {
            "id": "cmjbylmmv008k5p76i2h4ip03",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.487Z",
            "updatedAt": "2025-12-18T21:35:18.487Z"
          },
          {
            "id": "cmjbylmnv008m5p762sn919og",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "05:00",
            "heureFin": "15:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.523Z",
            "updatedAt": "2025-12-18T21:35:18.523Z"
          },
          {
            "id": "cmjbylmov008o5p761jxmepeh",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.559Z",
            "updatedAt": "2025-12-18T21:35:18.559Z"
          },
          {
            "id": "cmjbylmpv008q5p76eyebga15",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.595Z",
            "updatedAt": "2025-12-18T21:35:18.595Z"
          },
          {
            "id": "cmjbylmqv008s5p76jt47s665",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.631Z",
            "updatedAt": "2025-12-18T21:35:18.631Z"
          },
          {
            "id": "cmjbylmrv008u5p763q1lhoru",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.667Z",
            "updatedAt": "2025-12-18T21:35:18.667Z"
          },
          {
            "id": "cmjbylmsv008w5p76uvoshwmf",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxb9008cwb7s7cf7nqzp",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "15:00",
            "heureFin": "23:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.703Z",
            "updatedAt": "2025-12-18T21:35:18.703Z"
          }
        ]
      },
      {
        "id": "cmjakqxc8008ywb7sa2rwp3xm",
        "ligneId": "cmjakqxa8007owb7skzxm7jmn",
        "nom": "Samedi Aller",
        "direction": "EVRY-COURCOURONNESGare du Bras de Fer-Évry Génopôle → BRETIGNY-SUR-ORGEGare de Brétigny",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.841Z",
        "updatedAt": "2025-12-18T21:35:18.722Z",
        "services": [
          {
            "id": "cmjbylmud00905p76euj7ckpx",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxc8008ywb7sa2rwp3xm",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "06:00",
            "heureFin": "16:00",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.757Z",
            "updatedAt": "2025-12-18T21:35:18.757Z"
          },
          {
            "id": "cmjbylmvb00925p76eiz5yw2s",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxc8008ywb7sa2rwp3xm",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "16:00",
            "heureFin": "23:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.791Z",
            "updatedAt": "2025-12-18T21:35:18.791Z"
          }
        ]
      },
      {
        "id": "cmjakqxcg0094wb7scn11l5ib",
        "ligneId": "cmjakqxa8007owb7skzxm7jmn",
        "nom": "Samedi Retour",
        "direction": "BRETIGNY-SUR-ORGEGare de Brétigny → EVRY-COURCOURONNESGare du Bras de Fer-Évry Génopôle",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:19:44.849Z",
        "updatedAt": "2025-12-18T21:35:18.809Z",
        "services": [
          {
            "id": "cmjbylmwv00965p76wngbkp9y",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxcg0094wb7scn11l5ib",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "06:15",
            "heureFin": "16:15",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.847Z",
            "updatedAt": "2025-12-18T21:35:18.847Z"
          },
          {
            "id": "cmjbylmxv00985p76q5z5pqp3",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxcg0094wb7scn11l5ib",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "16:15",
            "heureFin": "23:41",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.883Z",
            "updatedAt": "2025-12-18T21:35:18.883Z"
          }
        ]
      },
      {
        "id": "cmjakqxco009awb7sww1shde5",
        "ligneId": "cmjakqxa8007owb7skzxm7jmn",
        "nom": "Dimanche & fériés Aller",
        "direction": "EVRY-COURCOURONNESGare du Bras de Fer-Évry Génopôle → BRETIGNY-SUR-ORGEGare de Brétigny",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.857Z",
        "updatedAt": "2025-12-18T21:35:18.901Z",
        "services": [
          {
            "id": "cmjbylmze009c5p76tisggbxy",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxco009awb7sww1shde5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "05:45",
            "heureFin": "15:45",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.938Z",
            "updatedAt": "2025-12-18T21:35:18.938Z"
          },
          {
            "id": "cmjbyln0d009e5p76b1j3sqfi",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxco009awb7sww1shde5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "15:45",
            "heureFin": "22:52",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:18.973Z",
            "updatedAt": "2025-12-18T21:35:18.973Z"
          }
        ]
      },
      {
        "id": "cmjakqxcy009gwb7s7a6at4ki",
        "ligneId": "cmjakqxa8007owb7skzxm7jmn",
        "nom": "Dimanche & fériés Retour",
        "direction": "BRETIGNY-SUR-ORGEGare de Brétigny → EVRY-COURCOURONNESGare du Bras de Fer-Évry Génopôle",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:19:44.866Z",
        "updatedAt": "2025-12-18T21:35:18.992Z",
        "services": [
          {
            "id": "cmjbyln1v009i5p76sfb46l89",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxcy009gwb7s7a6at4ki",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "06:15",
            "heureFin": "16:15",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.028Z",
            "updatedAt": "2025-12-18T21:35:19.028Z"
          },
          {
            "id": "cmjbyln2x009k5p767d699v1n",
            "ligneId": "cmjakqxa8007owb7skzxm7jmn",
            "sensId": "cmjakqxcy009gwb7s7a6at4ki",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "16:15",
            "heureFin": "23:20",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.065Z",
            "updatedAt": "2025-12-18T21:35:19.065Z"
          }
        ]
      }
    ]
  },
  {
    "id": "cmjakqxd8009lwb7syca1u33b",
    "numero": "4213",
    "nom": "LIGNE_4213",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "06:27",
    "heureFin": "20:03",
    "calendrierJson": "\"L; M; M; J; V\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T22:19:44.876Z",
    "updatedAt": "2025-12-18T21:35:19.084Z",
    "sens": [
      {
        "id": "cmjakqxdc009nwb7spe1294xh",
        "ligneId": "cmjakqxd8009lwb7syca1u33b",
        "nom": "Semaine Aller",
        "direction": "RIS-ORANGISCentre Commercial Aunettes → BONDOUFLEImprimerie Nationale",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.880Z",
        "updatedAt": "2025-12-18T21:35:19.102Z",
        "services": [
          {
            "id": "cmjbyln4x009p5p76a6npzqcv",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "06:39",
            "heureFin": "16:39",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.137Z",
            "updatedAt": "2025-12-18T21:35:19.137Z"
          },
          {
            "id": "cmjbyln5x009r5p76yvewfwy8",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "06:39",
            "heureFin": "16:39",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.174Z",
            "updatedAt": "2025-12-18T21:35:19.174Z"
          },
          {
            "id": "cmjbyln6z009t5p76bsi62vn1",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "06:39",
            "heureFin": "16:39",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.212Z",
            "updatedAt": "2025-12-18T21:35:19.212Z"
          },
          {
            "id": "cmjbyln81009v5p76h4s8wh9q",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "06:39",
            "heureFin": "16:39",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.250Z",
            "updatedAt": "2025-12-18T21:35:19.250Z"
          },
          {
            "id": "cmjbyln91009x5p7699pkt9lz",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "06:39",
            "heureFin": "16:39",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.285Z",
            "updatedAt": "2025-12-18T21:35:19.285Z"
          },
          {
            "id": "cmjbylna1009z5p76j3fdhkep",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "16:39",
            "heureFin": "20:03",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.321Z",
            "updatedAt": "2025-12-18T21:35:19.321Z"
          },
          {
            "id": "cmjbylnb100a15p765lv59lwx",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "16:39",
            "heureFin": "20:03",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.357Z",
            "updatedAt": "2025-12-18T21:35:19.357Z"
          },
          {
            "id": "cmjbylnc300a35p7651hwgd47",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "16:39",
            "heureFin": "20:03",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.395Z",
            "updatedAt": "2025-12-18T21:35:19.395Z"
          },
          {
            "id": "cmjbylnd300a55p76cmqra6hb",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "16:39",
            "heureFin": "20:03",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.431Z",
            "updatedAt": "2025-12-18T21:35:19.431Z"
          },
          {
            "id": "cmjbylne300a75p76vbo6an4h",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxdc009nwb7spe1294xh",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "16:39",
            "heureFin": "20:03",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.467Z",
            "updatedAt": "2025-12-18T21:35:19.467Z"
          }
        ]
      },
      {
        "id": "cmjakqxeg00a9wb7sqpyrj7yi",
        "ligneId": "cmjakqxd8009lwb7syca1u33b",
        "nom": "Semaine Retour",
        "direction": "BONDOUFLEImprimerie Nationale → RIS-ORANGISCentre Commercial Aunettes",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:19:44.921Z",
        "updatedAt": "2025-12-18T21:35:19.485Z",
        "services": [
          {
            "id": "cmjbylnfl00ab5p76gcufwz0i",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "06:27",
            "heureFin": "16:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.521Z",
            "updatedAt": "2025-12-18T21:35:19.521Z"
          },
          {
            "id": "cmjbylngl00ad5p7631bht55o",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "06:27",
            "heureFin": "16:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.557Z",
            "updatedAt": "2025-12-18T21:35:19.557Z"
          },
          {
            "id": "cmjbylnhl00af5p76plzr0hro",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "06:27",
            "heureFin": "16:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.593Z",
            "updatedAt": "2025-12-18T21:35:19.593Z"
          },
          {
            "id": "cmjbylnil00ah5p76rutr4c4t",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "06:27",
            "heureFin": "16:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.629Z",
            "updatedAt": "2025-12-18T21:35:19.629Z"
          },
          {
            "id": "cmjbylnjl00aj5p76b93oed76",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "06:27",
            "heureFin": "16:27",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.666Z",
            "updatedAt": "2025-12-18T21:35:19.666Z"
          },
          {
            "id": "cmjbylnkl00al5p76sblpo1d8",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "16:27",
            "heureFin": "19:34",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.701Z",
            "updatedAt": "2025-12-18T21:35:19.701Z"
          },
          {
            "id": "cmjbylnll00an5p76hafsl0e0",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "16:27",
            "heureFin": "19:34",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.737Z",
            "updatedAt": "2025-12-18T21:35:19.737Z"
          },
          {
            "id": "cmjbylnml00ap5p7690xktzed",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "16:27",
            "heureFin": "19:34",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.773Z",
            "updatedAt": "2025-12-18T21:35:19.773Z"
          },
          {
            "id": "cmjbylnnl00ar5p76vcj5k8gc",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "16:27",
            "heureFin": "19:34",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.809Z",
            "updatedAt": "2025-12-18T21:35:19.809Z"
          },
          {
            "id": "cmjbylnon00at5p76watfktb0",
            "ligneId": "cmjakqxd8009lwb7syca1u33b",
            "sensId": "cmjakqxeg00a9wb7sqpyrj7yi",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "16:27",
            "heureFin": "19:34",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.847Z",
            "updatedAt": "2025-12-18T21:35:19.847Z"
          }
        ]
      }
    ]
  },
  {
    "id": "cmjal8aru001y27u5rz0q1c1z",
    "numero": "N139",
    "nom": "NOCTILIEN_N139",
    "typesVehicules": "[\"autobus\"]",
    "statut": "Actif",
    "description": null,
    "heureDebut": "00:10",
    "heureFin": "07:16",
    "calendrierJson": "\"L; M; M; J; V; S; D\"",
    "demandeChrono": false,
    "contraintes": null,
    "createdAt": "2025-12-17T22:33:15.402Z",
    "updatedAt": "2025-12-18T21:35:19.870Z",
    "sens": [
      {
        "id": "cmjal8arx002027u5itfdf3s5",
        "ligneId": "cmjal8aru001y27u5rz0q1c1z",
        "nom": "Semaine Aller",
        "direction": "Paris (Gare de Lyon - Diderot) → Corbeil-Essonnes (Gare Henri Barbusse) | CARTE CHRONO EXIGÉE",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:33:15.405Z",
        "updatedAt": "2025-12-18T21:35:19.889Z",
        "services": [
          {
            "id": "cmjbylnqv00ay5p7663qf3cym",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8arx002027u5itfdf3s5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.928Z",
            "updatedAt": "2025-12-18T21:35:19.928Z"
          },
          {
            "id": "cmjbylnrx00b05p76t3mql0mi",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8arx002027u5itfdf3s5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:19.966Z",
            "updatedAt": "2025-12-18T21:35:19.966Z"
          },
          {
            "id": "cmjbylnsz00b25p7679cezy2t",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8arx002027u5itfdf3s5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.004Z",
            "updatedAt": "2025-12-18T21:35:20.004Z"
          },
          {
            "id": "cmjbylntz00b45p76jwz01ta5",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8arx002027u5itfdf3s5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.039Z",
            "updatedAt": "2025-12-18T21:35:20.039Z"
          },
          {
            "id": "cmjbylnuz00b65p76pz1wmfzr",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8arx002027u5itfdf3s5",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.076Z",
            "updatedAt": "2025-12-18T21:35:20.076Z"
          }
        ]
      },
      {
        "id": "cmjal8asj002c27u5sfgzn3m3",
        "ligneId": "cmjal8aru001y27u5rz0q1c1z",
        "nom": "Semaine Retour",
        "direction": "Corbeil-Essonnes (Gare Henri Barbusse) → Paris (Gare de Lyon - Diderot) | CARTE CHRONO EXIGÉE",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SEMAINE",
        "createdAt": "2025-12-17T22:33:15.428Z",
        "updatedAt": "2025-12-18T21:35:20.094Z",
        "services": [
          {
            "id": "cmjbylnwh00ba5p76zr6wr7tz",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8asj002c27u5sfgzn3m3",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-14T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.129Z",
            "updatedAt": "2025-12-18T21:35:20.129Z"
          },
          {
            "id": "cmjbylnxh00bc5p76dh6p4x7o",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8asj002c27u5sfgzn3m3",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-15T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.165Z",
            "updatedAt": "2025-12-18T21:35:20.165Z"
          },
          {
            "id": "cmjbylnyj00be5p765whbtuzq",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8asj002c27u5sfgzn3m3",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-16T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.203Z",
            "updatedAt": "2025-12-18T21:35:20.203Z"
          },
          {
            "id": "cmjbylnzj00bg5p76hqh3qxiq",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8asj002c27u5sfgzn3m3",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-17T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.239Z",
            "updatedAt": "2025-12-18T21:35:20.239Z"
          },
          {
            "id": "cmjbylo0j00bi5p76ssrjx4k1",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8asj002c27u5sfgzn3m3",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-18T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.275Z",
            "updatedAt": "2025-12-18T21:35:20.275Z"
          }
        ]
      },
      {
        "id": "cmjal8at5002o27u5081fjntr",
        "ligneId": "cmjal8aru001y27u5rz0q1c1z",
        "nom": "Samedi Aller",
        "direction": "Paris (Gare de Lyon - Diderot) → Corbeil-Essonnes (Gare Henri Barbusse) | CARTE CHRONO EXIGÉE",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:33:15.449Z",
        "updatedAt": "2025-12-18T21:35:20.294Z",
        "services": [
          {
            "id": "cmjbylo2300bm5p76tsok8ye8",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8at5002o27u5081fjntr",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.331Z",
            "updatedAt": "2025-12-18T21:35:20.331Z"
          }
        ]
      },
      {
        "id": "cmjal8atb002s27u5fm7u58n7",
        "ligneId": "cmjal8aru001y27u5rz0q1c1z",
        "nom": "Samedi Retour",
        "direction": "Corbeil-Essonnes (Gare Henri Barbusse) → Paris (Gare de Lyon - Diderot) | CARTE CHRONO EXIGÉE",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "SAMEDI",
        "createdAt": "2025-12-17T22:33:15.455Z",
        "updatedAt": "2025-12-18T21:35:20.350Z",
        "services": [
          {
            "id": "cmjbylo3n00bq5p76g3rtb9gp",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8atb002s27u5fm7u58n7",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-19T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.387Z",
            "updatedAt": "2025-12-18T21:35:20.387Z"
          }
        ]
      },
      {
        "id": "cmjal8ath002w27u539dvblql",
        "ligneId": "cmjal8aru001y27u5rz0q1c1z",
        "nom": "Dimanche & fériés Aller",
        "direction": "Paris (Gare de Lyon - Diderot) → Corbeil-Essonnes (Gare Henri Barbusse) | CARTE CHRONO EXIGÉE",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:33:15.461Z",
        "updatedAt": "2025-12-18T21:35:20.405Z",
        "services": [
          {
            "id": "cmjbylo5500bu5p76c6mxahwi",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8ath002w27u539dvblql",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "01:35",
            "heureFin": "07:16",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.441Z",
            "updatedAt": "2025-12-18T21:35:20.441Z"
          }
        ]
      },
      {
        "id": "cmjal8ato003027u51rxqgbiz",
        "ligneId": "cmjal8aru001y27u5rz0q1c1z",
        "nom": "Dimanche & fériés Retour",
        "direction": "Corbeil-Essonnes (Gare Henri Barbusse) → Paris (Gare de Lyon - Diderot) | CARTE CHRONO EXIGÉE",
        "ordre": 1,
        "statut": "Actif",
        "jourFonctionnement": "DIMANCHE_FERIES",
        "createdAt": "2025-12-17T22:33:15.468Z",
        "updatedAt": "2025-12-18T21:35:20.459Z",
        "services": [
          {
            "id": "cmjbylo6n00by5p76sxn9dq8u",
            "ligneId": "cmjal8aru001y27u5rz0q1c1z",
            "sensId": "cmjal8ato003027u51rxqgbiz",
            "conducteurId": null,
            "vehiculeAssigne": null,
            "date": "2025-12-20T23:00:00.000Z",
            "heureDebut": "00:10",
            "heureFin": "05:56",
            "statut": "Planifiée",
            "motifNonAssurance": null,
            "motifsDetails": null,
            "expirationPointage": null,
            "createdAt": "2025-12-18T21:35:20.495Z",
            "updatedAt": "2025-12-18T21:35:20.495Z"
          }
        ]
      }
    ]
  }
];
